import { useNode } from '@craftjs/core';
import {
  TitlePanel,
  AnswersPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormFieldOption } from 'src/features/generalForms/builder/types/BaseControlTypes';
import {
  FormRadioGroupInputComponent,
  FormRadioGroupInputProps,
} from 'src/features/generalForms/builder/types/RadioGroupInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppRadioGroupField } from 'src/features/generalForms/uikit/fields/radioGroup/radioGroupField';

export const FormRadioGroupInput: FormRadioGroupInputComponent = (props) => {
  const {
    connectors,
    styles,
    actions: { setProp },
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;
  const validationResult = useDataKeyValidation();

  const { paddingBottom, paddingLeft, paddingRight, paddingTop, ...restStyles } = styles;

  return (
    <div
      ref={(ref: HTMLDivElement) => connect(drag(ref))}
      style={{ paddingBottom, paddingLeft, paddingRight, paddingTop }}
    >
      <AppRadioGroupField<FormFieldOption, string>
        style={restStyles}
        disabled={props.disabled}
        options={props.options ?? []}
        valueField={'key'}
        labelField={'value'}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        isVertical={true}
        value={props.defaultValue}
        onChange={(selectedOption) => {
          setProp((p: FormRadioGroupInputProps) => (p.defaultValue = selectedOption.key), 500);
        }}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormRadioGroupInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <LayoutPanel sections={['ContentLayout', 'Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormRadioGroupInput.craft = {
  displayName: 'Radiogroup',
  rules: { canDrag: () => true },
  related: { settings: FormRadioGroupInputSettings },
};
